import React, { FC } from 'react';
import { css, StyledComponent } from 'styled-components';

export type ToolbarLayoutType = 'inner' | 'horizontal' | 'vertical';

export interface ToolbarParentProps {
  layoutType: ToolbarLayoutType;
}

export const ToolbarParent: FC<ToolbarParentProps> = ({ layoutType, ...rest }) => {
  return <div data-toolbar-layout-type={layoutType} {...rest} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const supportFieldLineLayout = (subSelector: StyledComponent<any, any> | string = '') => css`
  [data-toolbar-layout-type='inner'] > & {
    & ${subSelector} {
      border-radius: 0;
    }
  }

  [data-toolbar-layout-type='vertical'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  [data-toolbar-layout-type='horizontal'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
